import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Search = ({
  size,
  type,
  theme,
  className,
  dataTestId = "search-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.38654 1.23438C4.05351 1.23438 1.35156 3.93632 1.35156 7.26935C1.35156 10.6024 4.05351 13.3043 7.38654 13.3043C8.75292 13.3043 10.0132 12.8502 11.0248 12.0847L13.5094 14.5693C13.7698 14.8297 14.1919 14.8297 14.4522 14.5693C14.7126 14.309 14.7126 13.8868 14.4522 13.6265L11.9935 11.1678C12.8843 10.1162 13.4215 8.7555 13.4215 7.26935C13.4215 3.93632 10.7196 1.23438 7.38654 1.23438ZM2.6849 7.26935C2.6849 4.6727 4.78989 2.56771 7.38654 2.56771C9.98318 2.56771 12.0882 4.6727 12.0882 7.26935C12.0882 9.86599 9.98318 11.971 7.38654 11.971C4.78989 11.971 2.6849 9.86599 2.6849 7.26935Z"
    />
  </SVGIcon>
);
